export default __webpack_public_path__ + "img/google-calendar.4bbce23c.svg";